
export default function PageHeader(p: { children: React.ReactNode }) {
  return (
    <div className="w-full rounded-br-2xl rounded-bl-2xl border-gray-200 dark:bg-gray-700 dark:border-gray-600
     bg-background-color-asset-frontend pt-8 pb-8
    ">
      <div
        className={
          "max-w-lg lg:max-w-2xl mx-auto space-y-4 pl-8 pr-8 text-white"
        }
      >
        {p.children}
      </div>


    </div>
  );
}
